<template>
	<v-app id="inspire">
		<!-- <v-app-bar app height="80" >
			<v-spacer></v-spacer>
			<v-toolbar-title class="title-fixed">
				<img :src="randomImage" alt="Logo" class="logo" />
			</v-toolbar-title>
  

			<v-tabs class="tabs-limited" centered center-active>
        <v-tab
          v-for="link in filteredLinks"
          :key="link.id" 
          :to="link.route"
          @click="goAction(link.action)"
        >
          {{ link.title }}
        </v-tab>
      </v-tabs>

		<v-spacer></v-spacer>
		<v-divider
			vertical
			class="mx-4"
		></v-divider>
			<span>Language:</span>
				<v-menu offset-y>
					<template v-slot:activator="{ on, attrs }">
					<v-btn v-bind="attrs" v-on="on" icon>
						<span :class="`flag-icon flag-icon-${currentLanguage.flag}`"></span>
					</v-btn>
					</template>
					<v-list>
					<v-list-item
						v-for="lang in languages"
						:key="lang.code"
						@click="changeLanguage(lang.code)"
					>
						<v-list-item-avatar>
						<i :class="`flag-icon flag-icon-${lang.flag}`"></i>
						</v-list-item-avatar>
						<v-list-item-content>
						<v-list-item-title>{{ lang.name }}</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					</v-list>
					
			</v-menu>
		<v-divider
			vertical
		></v-divider>
			<v-spacer></v-spacer>
		</v-app-bar> -->
	<AppNavBar
		:account_id="account_id"
		:group_id="group_id"
		:user_name="user_name"
		:showlogin="showlogin"
		:currentLocale="currentLocale"
		:reference="reference"
		:credit = "credit"
		@emit_changeLanguage="changeLanguage"
		@emit_action="goAction"
		@open_login="OpenLogin"
		@open_register="OpenRegister"
		@logout="Logout"
	/>
	
	<v-main dark>
		<v-container>
			<v-row>
			<!-- <v-col
				cols="12"
				sm="2"
			>
				<v-sheet
				rounded="lg"
				min-height="268"
				>
				<SideLeft
				/>
				</v-sheet>
			</v-col> -->

			<v-col
				cols="12"
				sm="12"
			>
				<v-sheet
				min-height="70vh"
				rounded="lg"
				class="page-sheet"
				>
				<router-view
					:account_id="account_id"
					:group_id="group_id"
					:user_name="user_name"
					:showlogin="showlogin"
					:credit = "credit"
					@login="Login"
					@updatecredits="getBalance"
					/>
				</v-sheet>
			</v-col>

			<!-- <v-col
				cols="12"
				sm="2"
			>
				<v-sheet
				rounded="lg"
				min-height="268"
				>
				
				<SideRight
					:account_id="account_id"
					:group_id="group_id"
					:user_name="user_name"
					:showlogin="showlogin"
					:currentLocale="currentLocale"
      				:reference="reference"
					:credit = "credit"
					@emit_registrar="Registro"
					@emit_login="Login"
					@logout="Logout"
				/>
				</v-sheet>
			</v-col> -->
			</v-row>
		</v-container>

	<DialogLogin
		:show="showLoginDialog"
		:reference="my_refcode"
		:tab_register="tab_register"
		@open_login="OpenLogin"
		@close="showLoginDialog=false"
		@emit_login="Login"
	/>
	<DialogManager
		:show="showDialogManager"
		:account_id="account_id"
		:group_id="group_id"
		@login="Login"
		@close="showDialogManager=false"
	/>
	<DialogAnnounce
		:show="showDialogAnnounce"
		@close="showDialogAnnounce=false"
	/>
	
	</v-main>
		
	</v-app>
	
</template>
<script>
import Vue from "vue";
import axios from 'axios';

import SideLeft from "@/components/mainSideLeft.vue";
import SideRight from "@/components/mainSideRight.vue";
import DialogLogin from "@/components/dialog/dialogRegisterLogin.vue";
import DialogManager from "@/components/dialog/dialogManager.vue";
import DialogAnnounce from "@/components/dialog/dialogAnnounce.vue";
import AppNavBar from '@/components/ro-head.vue';
import { Icon } from '@iconify/vue2';
//import DialogVentas from "@/components/ProductoVender.vue";
export default {
    components: {
		AppNavBar,
    	Icon,
		SideRight,
		SideLeft,
		DialogLogin,
		DialogManager,
		DialogAnnounce,

	},
  name: 'App',

  data: () => ({    
	account_id: 0,
    group_id: 0,
	credit: 0,
	cashpoints: 0,
	user_name: '',
	my_refcode: '', //codigo de quien me invito
	reference: '', //codigo con que invito a otros
	token: '',
    name: 'Welcome',
	showlogin: true,
    email: '',
    status: false,
    drawer: true,
    mini: true,
    isLoading: false,
    model: null,
    search: '',
	tab_register: 0,
    showLoginDialog: false,
    showDialogManager: false,
    showDialogAnnounce: false,
    items_search: [],
    categorias:  [],
	
    links_headers: [
		{  id: 1, need_login: 0, title: 'Main', action: 'home', route: '/' },
		{  id: 2, need_login: 0, title: 'Information',  action: 'information', route: '/serverinfo' },
		{  id: 3, need_login: 0, title: 'Discord',  action: 'discord', route: 'https://discord.gg/ppMyV4e' },
		{  id: 4, need_login: 0, title: 'Wiki',  action: 'wiki', route: '/wiki' },
		{  id: 5, need_login: 0, title: 'Download',  action: 'download', route: '/downloads' },
		//{  id: 4, need_login: 0, title: 'Ranking',  action: 'ranking', route: '/ranking' },
		//{  id: 5, need_login: 0, title: 'Deathlog',  action: 'deathlog', route: '/deathlog' },
		//{  id: 6, need_login: 1, title: 'Shop',  action: 'cashshop', route: '/cashshop' },
		//{  id: 7, need_login: 0, title: 'Market',  action: 'Market', route: '/market' },
		{  id: 6, need_login: 0, title: 'Stream',  action: 'stream', route: '/' },
		{  id: 7, need_login: 0, title: 'Press Kit',  action: 'presskit', route: '/' }
  	],
	locales: ['en', 'es'],
	currentLocale: 'en',
	languages: [
		{ code: 'en', name: 'English', flag: 'us' },
        { code: 'es', name: 'Español', flag: 'es' },
        { code: 'pt', name: 'Português', flag: 'pt' },
        { code: 'fil', name: 'Filipino', flag: 'ph' },
      ],
	  images: [
        "/assets/imgs/logo/logo_01.png",
        "/assets/imgs/logo/logo_01.png"
      ],
      randomImage: "",
  }),
  mounted() {
	this.randomImage = this.images[Math.floor(Math.random() * this.images.length)];
	this.account_id = null;
	this.user_name = null;
	this.token = null;
	this.reference = null;
	this.group_id = null;
	if(localStorage.getItem("userData") && JSON.parse(localStorage.getItem("userData")) !== null){
		this.userData = JSON.parse(localStorage.getItem("userData"));
		let timestamp = Date.now();
		if(this.userData.expire_time < timestamp){
			this.account_id = null;
			this.user_name = null;
		}else{
			this.account_id = this.userData.account_id;
			this.user_name = this.userData.user_name;
			this.token = this.userData.token;
			this.reference = this.userData.reference;
			this.group_id = this.userData.group_id;
		}
	}
},
  computed: {
    currentLanguage() {
      return this.languages.find(lang => lang.code === this.$i18n.locale);
    },
	filteredLinks() {
		return this.links_headers.filter(link => {
		return link.need_login === 0 || (link.need_login === 1 && this.account_id > 0);
		});
	}
  },
  methods: {
    OpenProfile(){
      if(!this.account_id){
        this.showLoginRegister = true;
        return;
      }
    },
	changeLocale() {
      this.$i18n.locale = this.currentLocale;
    },
    Logout(){
      this.account_id = null;
      this.user_name = null;
      this.token = null;
      this.reference = null;
      localStorage.removeItem("userData");
    },
	changeLanguage(lang) {
		console.log("Changing language to:", lang);
      this.$i18n.locale = lang;
    },
	Registro(value){
		let user = { ...value };
		let threeDaysInMilliseconds = 3 * 24 * 60 * 60 * 1000;
		user.expire_time = Date.now() + threeDaysInMilliseconds;
		localStorage.setItem("userData", JSON.stringify(user));
		
		// Asignar propiedades a `this`
		this.account_id = user.account_id;
		this.user_name = user.user_name;
		this.email = user.email;
		this.group_id = user.group_id;
		this.status = user.status;
		this.reference = user.reference;
		this.token = user.token;
		this.showLoginRegister = false;
		// Mostrar mensaje de bienvenida
		Vue.swal.fire({
			icon: "success",
			html: `<p>Registration completed successfully</p><p>Thanks for registering ${user.user_name}</p>`
		});
	},
	OpenLogin(){
		this.tab_register = 0;
		this.my_refcode = localStorage.getItem('my_refcode');
      	this.showLoginDialog = true;
	},
	OpenRegister(){
		this.tab_register = 1;
		this.my_refcode = localStorage.getItem('my_refcode');
      	this.showLoginDialog = true;
	},
    Login(value){
      let timestamp = Date.now();
      let threeDaysInMilliseconds = 3 * 24 * 60 * 60 * 1000;
      timestamp += threeDaysInMilliseconds;
      value.expire_time = timestamp;
      localStorage.setItem("userData", JSON.stringify(value));
      this.account_id = value.account_id;
      this.user_name = value.user_name;
      this.reference = value.reference;
	  this.group_id = value.group_id;
      this.token = value.token;
      this.showlogin = false;
      this.showLoginDialog = false;
      return;
    },
    getBalance(){
      axios
      .get(this.URL('balance/'+this.account_id))
      .then(response => {
        let t = response.data;
        this.credit = t.balance_credits;
        this.cashpoints = t.cashpoints;
      })
      .catch(this.MSGBOX);
    },
	openDialogManager(){
		this.showDialogManager = true;
	},
	goAction(value){
		switch(value){
			case 'home': 		this.$router.push('/'); break;
			case 'information':	this.$router.push('/information'); break;
			case 'ranking':		this.$router.push('/ranking'); break;
			case 'wiki': window.open('https://wiki.ragnamex.com', '_blank'); this.$router.push('/'); break;
			case 'discord': window.open('https://discord.gg/ppMyV4e', '_blank'); this.$router.push('/'); break;
			case 'cashshop':		this.$router.push('/cashshop'); break;
			case 'market':		this.$router.push('/market'); break;
			case 'stream':		this.$router.push('/'); break;
			case 'presskit':	this.$router.push('/'); break;
			case 'download':	this.$router.push('/downloads'); break;
        }
	},

  },
  watch: {
	account_id : function (){
		if(!this.account_id){
			this.credit = 0;
			this.cashpoints = 0;
			return;
		}
    	this.getBalance(this.account_id);
    }
  },
}
</script>
<style>
/* ==========================================================
   RagnameX — Alternate Dimension
   Variables globales de tema (navy profundo + dorado + azul)
   ========================================================== */
:root {
  --rmx-navy-950: #00030D;
  --rmx-navy-900: #010e29;
  --rmx-navy-800: #101c33;
  --rmx-navy-700: #16233d;
  --rmx-gold: #d9ac5c;
  --rmx-gold-bright: #f0c878;
  --rmx-blue: #4a7fe0;
  --rmx-blue-bright: #6ea0ff;
  --rmx-text: #eaf0fb;
  --rmx-text-muted: #8a97ad;
  --rmx-green: #3ecf6c;
}

/* IMPORTANTE: v-app se monta con id="inspire" (ver template arriba), por lo
   que el <div id="app"> original de index.html es reemplazado por completo
   al montar Vue. Un selector "#app" aquí nunca coincide con nada real tras
   el montaje — hay que apuntar a la clase .v-application, que Vuetify SIEMPRE
   aplica al elemento raíz sin importar el id que se le asigne. */
.v-application {
  min-height: 100vh;
  background:
    radial-gradient(1px 1px at 12% 18%, rgba(234, 240, 251, 0.55) 0, transparent 55%),
    radial-gradient(1px 1px at 68% 8%, rgba(234, 240, 251, 0.4) 0, transparent 55%),
    radial-gradient(1.5px 1.5px at 40% 32%, rgba(234, 240, 251, 0.5) 0, transparent 55%),
    radial-gradient(1px 1px at 85% 45%, rgba(234, 240, 251, 0.35) 0, transparent 55%),
    radial-gradient(1.5px 1.5px at 22% 62%, rgba(234, 240, 251, 0.45) 0, transparent 55%),
    radial-gradient(1px 1px at 92% 78%, rgba(234, 240, 251, 0.4) 0, transparent 55%),
    radial-gradient(160vw 90vh at 50% -10%, rgba(74, 127, 224, 0.16), transparent 60%),
    linear-gradient(180deg, var(--rmx-navy-950) 0%, var(--rmx-navy-900) 45%, var(--rmx-navy-950) 100%)
    fixed !important;
  background-size: 200px 200px, 250px 250px, 180px 180px, 220px 220px, 190px 190px, 230px 230px, 100% 100%, 100% 100%;
  color: var(--rmx-text);
}
.clickable {
cursor: pointer;
}
.title-fixed {
  white-space: nowrap;  /* Evita salto de línea */
  overflow: hidden;     /* Evita que se desborde */
  text-overflow: clip;  /* Opcional: no muestra "..." */
  min-width: 200px;     /* Ajusta el tamaño mínimo */
  flex-shrink: 0;       /* Evita que se encoja */
}

.tabs-limited {
  max-width: 50%;  /* Reduce el espacio de las tabs */
  flex-shrink: 1;
}
.avatar-image {
  border: 2px solid var(--rmx-gold); /* Borde dorado acorde al tema RagnameX */
  border-radius: 50%; /* Opcional: para hacer que el borde sea redondeado en imágenes circulares */
}

.page-sheet.v-sheet.v-sheet {
  background: transparent !important;
  box-shadow: none !important;
}

</style>